module.exports = __webpack_public_path__ + "images/places/export_2927-5d81616e94f5ff86c96657a7515c3354.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/export_2927.jpg
 ** module id = 300
 ** module chunks = 0
 **/